module.exports = __webpack_public_path__ + "media/images/truck-5fa61e8a.png";